import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Grid from "@mui/material/Grid";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,FormControlLabel,
    Checkbox
  } from "@mui/material";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Cabledetails from "./Components/Cabledetails.json"
import Cableimages from "./Components/Cableimages.json"
import Installationconditions from "./Components/Installationconditions.json"
import deratingData from "./Components/deratingWizardOptions.json"
import additionalDeratingData from "./Components/additionalDeratingDetailsData.json"
import deratingImage from "./Components/Deratingimages.json"
import cablesizze from "./Components/currentcapacitydata.json"

function InputComponent({ handleInputChange, inputDataSave }) {
  const [kvarating, setkvarating] = useState("1143.15");
  const [loadCurrent, setLoadCurrent] = useState("100");
  const [kvaChanged, setKvaChanged] = useState(false);
  const [currentChanged, setCurrentChanged] = useState(false);
  const [voltagelevel, setVoltageLevel] = useState(6.6);
  const [voltagelabel, setVoltageLabel] = useState("3.8/6.6");
  const [faultlevel, setFaultLevel] = useState(20);
  const [faulttriptime, setFaultTripTime] = useState(0.1);  
  const [conductor, setConductor] = useState("Copper");
  const [cabletype, setCableType] = useState("Single Core Screened & PVC Sheathed");
  const [installation, setInstallation] = useState("Cables with minimum cable spacings in air as shown and installed on ladders, racks, perforated or unperforated trays, cleats or hangers (flat formation)");
  const [deratingConditions, setDeratingConditions] = useState({});
  const [additionalderatingConditions, setAdditionalDeratingConditions] = useState({});
  const [activeCableSizingMode, setActiveCableSizingMode] = useState("Automatic");
  const [selectedCircuit, setSelectedCircuit] = useState("1");
  const [selectedCableSize, setSelectedCableSize] = useState("16");

  const conductorOptions = Object.keys(Cabledetails)
  const cableTypeOptions = Object.keys(Cabledetails[conductor])
  const voltageLevelOptions = Object.entries(Cabledetails[conductor][cabletype]);
  const cablecrosssection = Cableimages[cabletype];
  const installationoption =  Object.entries(Installationconditions[cabletype]);

  const deratingOptions = cabletype && installation ? deratingData[cabletype][installation] || [] : [];
  const additionalDeratingOptions = cabletype && installation && additionalDeratingData[cabletype][installation] && additionalDeratingData[cabletype][installation][deratingConditions["Installation"]] ? additionalDeratingData[cabletype][installation][deratingConditions["Installation"]] || [] : [];
  const installationImage = cabletype && installation ? deratingImage[cabletype][deratingConditions["Installation"]] || deratingImage[cabletype][installation] : "";

  const avtivecablesizeoption = cabletype
    ? Object.entries(
        cablesizze?.[cabletype]?.[voltagelabel]?.[conductor]?.[installation] || {}
      ).sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]))
    : [];


  const handleConductorChange = (event) => {
    setConductor(event.target.value);
  };

    const handleCableTypeChange = (event) => {
    setCableType(event.target.value);
  };

const voltagelevels = [["3.8/6.6",6.6],["6.35/11",11],["12.7/22",22],["19/33",33]]

const handleVoltageLevelChange = (event) => {
  const selectedVoltage = event.target.value;
  setVoltageLevel(selectedVoltage);

  // Find the matching label from voltageLevelOptions
  const matchingLabel = voltagelevels.find(
    ([label, voltage]) => voltage === selectedVoltage
  )?.[0];

  setVoltageLabel(matchingLabel || "");
};

// When user manually edits kva (e.g. input field)
const handleKvaChange = (value) => {
  setkvarating(value);
  setKvaChanged(true);
};

// When user manually edits current (e.g. input field)
const handleCurrentChange = (value) => {
  setLoadCurrent(value);
  setCurrentChanged(true);
};

// Convert current → kva
useEffect(() => {
  if (inputDataSave.loadCurrent === undefined) {
  if (!currentChanged || !voltagelevel) return;

  const kva = voltagelevel * loadCurrent * Math.sqrt(3);
  const rounded = parseFloat(kva.toFixed(2));

  if (parseFloat(kvarating) !== rounded) {
    setkvarating(rounded);
  }

  setCurrentChanged(false);
 } // reset flag after update
}, [loadCurrent, voltagelevel]);

// Convert kva → current
useEffect(() => {
    if (inputDataSave.loadCurrent === undefined) {
  if (!kvaChanged || !voltagelevel) return;

  const current = (kvarating) / (voltagelevel * Math.sqrt(3));
  const rounded = parseFloat(current.toFixed(2));

  if (parseFloat(loadCurrent) !== rounded) {
    setLoadCurrent(rounded);
  }

  setKvaChanged(false); // reset flag after update
}
}, [kvarating, voltagelevel]);

useEffect(() => {
      if (inputDataSave.voltagelevel === undefined) {
  const kva = voltagelevel * loadCurrent * Math.sqrt(3);
  const rounded = parseFloat(kva.toFixed(2));
  if (parseFloat(kvarating) !== rounded) {
    setkvarating(rounded);
  }}

}, [voltagelevel]);




  useEffect(() => {
          if (inputDataSave.voltagelevel === undefined) {
  setVoltageLevel(voltageLevelOptions[0][1]);
  setVoltageLabel(voltageLevelOptions[0][0]);
          }
}
  
  , [cabletype]);

    useEffect(() => {
             if (inputDataSave.installation === undefined) {   
  setInstallation(installationoption[0][0]);}}
  , [cabletype]);

useEffect(() => {
     if (inputDataSave.selectedCableSize === undefined) {  
  if (avtivecablesizeoption.length > 0 && Array.isArray(avtivecablesizeoption[0])) {
    setSelectedCableSize(avtivecablesizeoption[0][0]);
  }}
}, [voltagelabel, conductor, cabletype]);



  
  const getInitialAdditionalDeratingValues = (options) => {
      const initialValues = {};
      options.forEach((option) => {
          Object.entries(option).forEach(([label, values]) => {
              if (values.length > 0) {
                  initialValues[label] = values[0];
              }
          });
      });
      return initialValues;
  };
  useEffect(() => {
    if (inputDataSave.additionalderatingConditions === undefined) {  
      if (additionalDeratingOptions.length > 0) {
          const initialValues = getInitialAdditionalDeratingValues(additionalDeratingOptions);
          setAdditionalDeratingConditions(initialValues);
      }}
  }, [deratingConditions]);
  
  const getInitialDeratingValues = (options) => {
      const initialValues = {};
      options.forEach((option) => {
          Object.entries(option).forEach(([label, values]) => {
              if (values.length > 0) {
                  initialValues[label] = values[0];
              }
          });
      });
      return initialValues;
  };
  useEffect(() => {
    if (inputDataSave.deratingConditions === undefined) {  
      if (deratingOptions.length > 0) {
          const initialValues = getInitialDeratingValues(deratingOptions);
          setDeratingConditions(initialValues);
      }}
  }, [deratingOptions]);
  
  
  useEffect(() => {
     if (inputDataSave.installation === undefined) {  
  setAdditionalDeratingConditions({})}
  }, [installation]);

  const hasMatchingKeys = (options, conditions) => {
    const optionKeys = options.flatMap(option => Object.keys(option));
    const conditionKeys = Object.keys(conditions);
    return optionKeys.every(key => conditionKeys.includes(key));
};

const numberofcircuit = [1,2,3,4,5,6,7,8,9,10]


useEffect(() => {
  if (inputDataSave.kvarating !== undefined) setkvarating(inputDataSave.kvarating);
  if (inputDataSave.loadCurrent !== undefined) setLoadCurrent(inputDataSave.loadCurrent);
  if (inputDataSave.kvaChanged !== undefined) setKvaChanged(inputDataSave.kvaChanged);
  if (inputDataSave.currentChanged !== undefined) setCurrentChanged(inputDataSave.currentChanged);
  if (inputDataSave.voltagelevel !== undefined) setVoltageLevel(inputDataSave.voltagelevel);
  if (inputDataSave.voltagelabel !== undefined) setVoltageLabel(inputDataSave.voltagelabel);
  if (inputDataSave.faultlevel !== undefined) setFaultLevel(inputDataSave.faultlevel);
  if (inputDataSave.faulttriptime !== undefined) setFaultTripTime(inputDataSave.faulttriptime);
  if (inputDataSave.conductor !== undefined) setConductor(inputDataSave.conductor);
  if (inputDataSave.cabletype !== undefined) setCableType(inputDataSave.cabletype);
  if (inputDataSave.installation !== undefined) setInstallation(inputDataSave.installation);
  if (inputDataSave.deratingConditions !== undefined) setDeratingConditions(inputDataSave.deratingConditions);
  if (inputDataSave.additionalderatingConditions !== undefined) setAdditionalDeratingConditions(inputDataSave.additionalderatingConditions);
  if (inputDataSave.selectedCircuit !== undefined) setSelectedCircuit(inputDataSave.selectedCircuit);
  if (inputDataSave.selectedCableSize !== undefined) setSelectedCableSize(inputDataSave.selectedCableSize);
  if (inputDataSave.activeCableSizingMode !== undefined) setActiveCableSizingMode(inputDataSave.activeCableSizingMode);
  console.log("loadCurrent",inputDataSave)

}, [inputDataSave]);


  useEffect(() => {
    const inputData = {
      kvarating,
      loadCurrent,
      kvaChanged,
      currentChanged,
      voltagelevel,
      voltagelabel,
      faultlevel,
      faulttriptime,
      conductor,
      cabletype,
      installation,
      deratingConditions,
      additionalderatingConditions,
      activeCableSizingMode,
      selectedCircuit,
      selectedCableSize,
    };
      handleInputChange(inputData);
  }, [kvarating,loadCurrent,kvaChanged,currentChanged,voltagelevel,voltagelabel,faultlevel,faulttriptime,conductor,cabletype,installation,deratingConditions,additionalderatingConditions,activeCableSizingMode,selectedCircuit,selectedCableSize]);






  return ( 
        <div className="App">
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh" }}
      >
        <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                LOAD DETAILS
              </Typography>
            </Stack>

            <Box component="form" noValidate autoComplete="off">
              <TextField
                label="Load Current (A)"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={loadCurrent}
                onChange={(e) => handleCurrentChange(e.target.value)}
                InputProps={{
                  style: { fontSize: "1.1rem",
                    fontFamily: "'Hubballi', sans-serif",
                   },
                   
                }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />

                            <TextField
                label="Load (kVA)"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={kvarating}
                onChange={(e) => handleKvaChange(e.target.value)}
                InputProps={{
                  style: { fontSize: "1.1rem",
                    fontFamily: "'Hubballi', sans-serif",
                   },
                   
                }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />
            </Box>

                                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                      <Typography variant="h5"          
                       sx={{
                        fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                        fontWeight: "700",
                        fontFamily: "'Hubballi', sans-serif",
                        letterSpacing: "1px",
                        paddingTop: "1rem",
                    }}> 
                        INSTALLATION DETAILS
                      </Typography>
                    </Stack>
        
                    <Box component="form" noValidate autoComplete="off">
        
                    </Box>
        
                    <Box component="form" noValidate autoComplete="off">
                    <FormControl fullWidth margin="normal" label="Installation Method">
                    <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        Installation Method
                    </InputLabel>
                    <Select
                        value={installation}
                        onChange={(e) => setInstallation(e.target.value)}
                        label="Installation Methods"
                        sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxWidth: "300px", // Set a max width to control the overall popup size
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                },
                            },
                        }}
                    >
                        {installationoption.map(([ type, imgPath ]) => (
                        <MenuItem key={type} value={type}>
                            <Box display="flex" alignItems="center" gap={2}>
        
                            <Typography sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem",                                whiteSpace: "normal", 
                                        wordWrap: "break-word", 
                                        overflowWrap: "break-word" }}>
                                {type}
                            </Typography>
                            <img
                                src={imgPath}
                                alt={type}
                                width={100}
                                height={100}
                                style={{ objectFit: "contain", borderRadius: "4px" }}
                            />
                            </Box>
                        </MenuItem>
        
                        
                        ))}
                    </Select>
                    </FormControl>        
                    </Box>
          </Paper>
        </Grid>


         <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "700",
                  fontFamily: "'Hubballi', sans-serif",
                  letterSpacing: "1px",
                }}
              >
                CABLE DETAILS
              </Typography>
            </Stack>

                        <Box component="form" noValidate autoComplete="off">
                        <FormControl fullWidth margin="normal">
                            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Conductor</InputLabel>
                            <Select
                                value={conductor}
                                onChange={handleConductorChange}
                                label="Conductor"
                                sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                            >
                                {conductorOptions.map((type) => (
                                <MenuItem key={type} value={type} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                                    {type}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
            
            
            <FormControl fullWidth margin="normal">
                            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Cable Type</InputLabel>
                            <Select
                                value={cabletype}
                                onChange={handleCableTypeChange}
                                label="Cable Type"
                                sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                            >
                                {cableTypeOptions.map((type) => (
                                <MenuItem key={type} value={type} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                                    {type}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
            
            
                            <FormControl fullWidth margin="normal">
                            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Voltage Level (kV)</InputLabel>
                            <Select
                                value={voltagelevel}
                                onChange={handleVoltageLevelChange}
                                label="Voltage Level (Kv)"
                                sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                            >
                                {voltageLevelOptions.map(([label, voltage]) => (
                                <MenuItem key={label} value={voltage} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                                    {label}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
            
                        </Box>






        

          </Paper>
        </Grid>


         <Grid item xs={11} sm={11} md={4}>
<Paper
  elevation={6}
  style={{
    padding: "2.5rem",
    borderRadius: "20px",
    background: "#ffffff",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
  }}
>
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      CABLE CROSSSECTION
    </Typography>
  </Stack>

  <Box sx={{ display: "flex", justifyContent: "center" }}>
    <img
      src={cablecrosssection}
      width="60%"
      height="60%"
      style={{ objectFit: "contain", borderRadius: "4px" }}
    />
  </Box>
</Paper>
        </Grid>
        
        <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                SHORT CIRCUIT DETAILS
              </Typography>
            </Stack>

            <Box component="form" noValidate autoComplete="off">
              <TextField
                label="Supply Fault Level (kA)"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={faultlevel}
                onChange={(e) => setFaultLevel(e.target.value)}
                InputProps={{
                  style: { fontSize: "1.1rem",
                    fontFamily: "'Hubballi', sans-serif",
                   },
                   
                }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />

                            <TextField
                label="Short Circuit Duration (s)"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={faulttriptime}
                onChange={(e) => setFaultTripTime(e.target.value)}
                InputProps={{
                  style: { fontSize: "1.1rem",
                    fontFamily: "'Hubballi', sans-serif",
                   },
                   
                }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />
            </Box>
          </Paper>
        </Grid>



<Grid item xs={11} sm={11} md={4}>
  <Paper
    elevation={6}
    style={{
      padding: "2.5rem",
      borderRadius: "20px",
      background: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
        }}
      >
        DERATING WIZARD (AS3008:1.1,2017)
      </Typography>
    </Stack>

    {/* Internal Two-Column Layout */}
    <Grid container spacing={2}>
      {/* Inputs */}
      <Grid item xs={12} md={8}>
        {hasMatchingKeys(deratingOptions, deratingConditions) &&
          deratingOptions.map((option, index) =>
            Object.entries(option).map(([label, values], i) => (
              <FormControl fullWidth margin="normal" key={`${index}-${i}`}>
                <InputLabel
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {label}
                </InputLabel>
                <Select
                  value={deratingConditions[label]}
                  onChange={(e) =>
                    setDeratingConditions((prev) => ({
                      ...prev,
                      [label]: e.target.value,
                    }))
                  }
                  label={label}
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {values.map((value, j) => (
                    <MenuItem
                      key={j}
                      value={value}
                      sx={{
                        fontFamily: "'Hubballi', sans-serif",
                        fontSize: "1.1rem",
                      }}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))
          )}

        {hasMatchingKeys(
          additionalDeratingOptions,
          additionalderatingConditions
        ) &&
          additionalDeratingOptions.map((option, index) =>
            Object.entries(option).map(([label, values], i) => (
              <FormControl fullWidth margin="normal" key={`${index}-${i}`}>
                <InputLabel
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {label}
                </InputLabel>
                <Select
                  value={additionalderatingConditions[label]}
                  onChange={(e) =>
                    setAdditionalDeratingConditions((prev) => ({
                      ...prev,
                      [label]: e.target.value,
                    }))
                  }
                  label={label}
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {values.map((value, j) => (
                    <MenuItem
                      key={j}
                      value={value}
                      sx={{
                        fontFamily: "'Hubballi', sans-serif",
                        fontSize: "1.1rem",
                      }}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))
          )}
      </Grid>

      {/* Image */}
      {installationImage && (
        <Grid item xs={12} md={4} display="flex" justifyContent="center" alignItems="center">
          <img
            src={installationImage}
            alt=""
            width={150}
            height={150}
            style={{ objectFit: "contain", borderRadius: "4px" }}
          />
        </Grid>
      )}
    </Grid>
  </Paper>
</Grid>


<Grid item xs={11} sm={11} md={4}>
  <Paper
    elevation={6}
    style={{
      padding: "2.5rem",
      borderRadius: "20px",
      background: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
        }}
      >
        ACTIVE CABLE SIZING
      </Typography>
    </Stack>

    <Box component="form" noValidate autoComplete="off">


      {/* Active Cable Sizing Dropdown */}
      <FormControl fullWidth margin="normal">
        <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
          Active Cable Sizing
        </InputLabel>
        <Select
          value={activeCableSizingMode}
          onChange={(e) => setActiveCableSizingMode(e.target.value)}
          label="Active Cable Sizing"
          sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
        >
          <MenuItem value="Automatic" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            Automatic
          </MenuItem>
          <MenuItem value="User Selection" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            User Selection
          </MenuItem>
        </Select>
      </FormControl>

      {activeCableSizingMode === "User Selection" && (
        <>


          {/* Show circuit x cable size side-by-side with '×' once circuit is selected */}
          {selectedCircuit && (
            <Grid container spacing={2} alignItems="center">
              {/* Circuits Input (readonly) - 3 columns out of 12 (1/4) */}
              <Grid item xs={3}>
          {/* Number of Circuits Dropdown */}
          <FormControl fullWidth margin="normal">
            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
              No of Circuits
            </InputLabel>
            <Select
              value={selectedCircuit}
              onChange={(e) => setSelectedCircuit(e.target.value)}
              label="No of Circuits"
              sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
            >
              {numberofcircuit.map((num) => (
                <MenuItem key={num} value={num} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                  {num}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
              </Grid>

              {/* × symbol - 1 column out of 12 */}
              <Grid item xs={1} sx={{ textAlign: "center", fontSize: "2rem", fontWeight: "",fontFamily: "'Hubballi', sans-serif" }}>
                ×
              </Grid>

              {/* Cable Size Dropdown - 8 columns out of 12 (2/3) */}
              <Grid item xs={8}>
                <FormControl fullWidth>
                  <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                    Cable Size (mm2)
                  </InputLabel>
                  <Select
                    value={selectedCableSize}
                    onChange={(e) => setSelectedCableSize(e.target.value)}
                    label="Cable Size (mm2)"
                    sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                  >
                    {avtivecablesizeoption.map(([size, _]) => (
                      <MenuItem key={size} value={size} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}
        </>
      )}

      </Box>
      </Paper>

      </Grid>


        
</Grid>



        </div>
   );
}

export default InputComponent;
